import { render, staticRenderFns } from "./IconRewardToShip.vue?vue&type=template&id=5777c97e"
import script from "./IconRewardToShip.vue?vue&type=script&lang=js"
export * from "./IconRewardToShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports